module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Column-names",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('span', {
    staticClass: "Column-names"
  }, [_c('a', {
    attrs: {
      "id": "_idTOCAnchor-6"
    }
  }), _vm._v("Peace Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "Column-dates"
  }, [_c('span', {
    staticClass: "Column-dates _idGenCharOverride-5"
  }, [_vm._v("January 24, 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("“Have you asked your dad about his war experiences?” the woman asked me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("As the interviewer, I was supposed to be the one asking questions, but perhaps this was to be expected from my interviewee, a retired Marine and currently a writing teacher.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("The answer was no, and even as she encouraged me to do so, I knew that I would not. Several years ago, my father gave me his trove of photos from Vietnam, so I had pictures, but few words.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("When my father and my husband would start swapping stories from their common Air Force experiences, I would listen carefully, gleaning details. Mostly, they talked about aircraft they had flown in or worked on. Dad liked to recall the people he knew, chuckling about crusty generals or “this ol’ E-8 I flew with.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("About the war, he was silent, and I respected his silence.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("The woman’s question came back to me when I received the news just after Christmas that my father was gone. A car accident claimed his life on December 30, 2009.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("My earliest memory is of the day my dad returned from Vietnam. I woke up in the backseat of our car and saw his big round “wheel hat” silhouetted against the sun. I couldn’t see his face, but I remember his voice as he leaned in to pick me up. I was two years old, so as far back as I can remember, I knew my dad had been to war, but he never told war stories.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("He told other stories. When I was in grade school, we lived in Alaska. When Daddy would come home, I would sit on his lap, breathe in the smell of his flight suit, eat the dessert he saved from his flight lunch, and hear about the places he had been and the people who had flown with him.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("I have an old photo that reminds me of one of his stories. It shows my dad, who was a crew chief, standing in front of his plane on a snowy tarmac, circa 1969. Beside him is Santa Claus, who hitched a ride to help deliver supplies in remote Arctic areas. That was the kind of story Dad preferred to tell.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("In letters from his overseas tours, the only hardship he mentioned was missing us, usually reminding me to say my prayers and mind my mother.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("Only when I was older did I learn that Dad’s mission in Vietnam was a dangerous one, flying over enemy territory, that he had lost friends there, that he had bad dreams.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("Long after the war, as I was growing up, our family experienced other kinds of turmoil, which we weathered together and apart. Fallout from his untold stories? Perhaps, in part.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("But do I regret not asking those questions? I don’t think so. My father preferred not to talk about some experiences, but I’ve seen how those events shaped him and his life. I knew the man, so in some way I do know the stories, even the ones he didn’t tell.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("The words that mattered were said. When I talked to him on Christmas Day—from Germany to Texas—our last words to each other were what they always were at the end of a phone call: “I love you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("For Veteran’s Day in 2008, I wrote a magazine article about my dad and his reluctance to tell war stories and sent him a copy. Now I’m especially glad that I did.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("The closing lines were:")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("“Peace is not free or easy. It is hard won. It must be pursued and war stories are the story of that pursuit ")]), _c('span', {
    staticClass: "Text CharOverride-14"
  }, [_vm._v("…")]), _c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v(" Still, the best stories are peace stories. Not fairy tales pretending that war and death and suffering don’t happen, but true stories of peace reaching beyond conflict ")]), _c('span', {
    staticClass: "Text CharOverride-14"
  }, [_vm._v("…")]), _c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v(" So thanks, Dad, for the peace stories. We owe our gratitude to you, and to all veterans who have endured the real story of war, so that others are free to hear the story of peace.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Stars-End-Column"
  }, [_c('span', {
    staticClass: "Stars-End-Column _idGenCharOverride-6"
  }, [_vm._v("*** ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e7f4c49","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/spousecalls7.vue
// module id = 78
// module chunks = 0